class CoHeaderDesktopNav extends HTMLElement {
  static OPEN_DELAY = 250;
  static CLOSE_DELAY = 100;

  constructor() {
    super();
  }

  connectedCallback() {
    this._header = document.querySelector('header');
    this._bindMenuPositions();
    this._bindHoverMenu();
    this._bindScrollResize();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScrollResize);
    window.removeEventListener('resize', this._onScrollResize);
  }

  _updateMenuPosition(menu) {
    if (!this._header) return;
    menu.style.top = `${(this._header.offsetHeight - 1)}px`;
  }

  _bindMenuPositions() {
    this.querySelectorAll('.site-nav__details').forEach((details) => {
      const menu = details.querySelector('.site-nav__dropdown');
      if (!menu) return;

      details.addEventListener('toggle', () => {
        if (details.open) this._updateMenuPosition(menu);
      });
    });
  }

  _bindHoverMenu() {
    const allDetails = this.querySelectorAll('.site-nav__details[data-hover="true"]');

    allDetails.forEach((detail) => {
      // Prevent theme.js hoverMenu() from matching these elements
      detail.dataset.hover = 'controlled';

      let openTimer = null;
      let openAllowed = false;
      const summary = detail.querySelector('summary');
      const summaryLink = summary?.dataset.link;
      const menu = detail.querySelector('.site-nav__dropdown');

      const openDetail = () => {
        allDetails.forEach((d) => {
          if (d !== detail) {
            d.removeAttribute('open');
            d.setAttribute('aria-expanded', 'false');
            d.classList.remove('is-closing');
          }
        });
        openAllowed = true;
        detail.setAttribute('open', '');
        detail.setAttribute('aria-expanded', 'true');
        if (menu) {
          menu.style.opacity = '0';
          menu.offsetHeight;
          menu.style.opacity = '';
          this._updateMenuPosition(menu);
        }
      };

      const scheduleOpen = () => {
        if (detail.hasAttribute('open') || openTimer) return;
        openTimer = setTimeout(() => {
          openTimer = null;
          if (detail.matches(':hover')) openDetail();
        }, CoHeaderDesktopNav.OPEN_DELAY);
      };

      const cancelOpen = () => {
        if (openTimer) {
          clearTimeout(openTimer);
          openTimer = null;
        }
      };

      // Block any unauthorized open (from theme.js or native toggle)
      detail.addEventListener('toggle', () => {
        if (detail.open && !openAllowed) {
          detail.removeAttribute('open');
          return;
        }
        openAllowed = false;
      });

      summary?.addEventListener('click', (e) => {
        e.preventDefault();
        if (summaryLink) window.location.href = summaryLink;
      });

      detail.addEventListener('mouseenter', () => {
        detail.classList.remove('is-closing');
        scheduleOpen();
      });

      detail.addEventListener('mouseleave', () => {
        cancelOpen();
        if (detail.hasAttribute('open')) {
          detail.classList.add('is-closing');
          setTimeout(() => {
            if (!detail.matches(':hover')) {
              openAllowed = true;
              detail.removeAttribute('open');
              detail.setAttribute('aria-expanded', 'false');
            }
            detail.classList.remove('is-closing');
          }, CoHeaderDesktopNav.CLOSE_DELAY);
        }
      });

      detail.addEventListener('focusin', () => {
        cancelOpen();
        scheduleOpen();
      });

      detail.addEventListener('focusout', () => {
        cancelOpen();
        if (detail.hasAttribute('open') && !detail.matches(':focus-within')) {
          openAllowed = true;
          detail.removeAttribute('open');
          detail.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  _bindScrollResize() {
    this._onScrollResize = () => {
      this.querySelectorAll('details[open] .site-nav__dropdown').forEach((menu) => {
        this._updateMenuPosition(menu);
      });
    };

    window.addEventListener('scroll', this._onScrollResize, { passive: true });
    window.addEventListener('resize', this._onScrollResize, { passive: true });
  }
}

if (!customElements.get("co-header-desktop-nav")) {
	customElements.define("co-header-desktop-nav", CoHeaderDesktopNav);
}